export enum TPCategory {
  CAT_6 = 'Cat 6',
  CAT_6E = 'Cat 6E',
  CAT_6A = 'Cat 6A',
  CAT_7 = 'Cat 7',
  CAT_8 = 'Cat 8',
}
